import { AfterViewInit, Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import * as _ from 'lodash';
import { limitOptions } from '../../services/ref';
@Component({
    selector: 'securisation-moins-values',
    templateUrl: './securisation-moins-values.component.html',
    styleUrls: ['./securisation-moins-values.component.scss'],
    standalone: false
})
export class SecurisationMoinsValuesComponent
  extends EaSubscriptionBuilder
  implements OnInit, AfterViewInit
{
  hideAlert = false;
  _ = _;
  //PERCENT_5, PERCENT_10, PERCENT_15, PERCENT_20, PERCENT_30, CUSTOM
  limitOtions = limitOptions;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }
  ngOnInit(): void {
    this.subscriptionFacade.initForm(this);
  }
  ngAfterViewInit(): void {}
  deleteFields(index) {
    this.avOptionSecurisationMoinsValuesLimits.removeAt(index);

    this.avOptionSecurisationMoinsValuesLimits.markAsDirty();
  }
  onSubmit() {
    this.form.markAsDirty();

    this.subscriptionFacade.submitPledge(this);
  }
  get controls() {
    if (
      this.products
        .get(`${0}`)
        .get('parameters')
        .get('avOptionSecurisationMoinsValuesTotaliteSupport')?.value
    ) {
      return [this.avOptionSecurisationMoinsValuesLimits.controls[0]];
    }
    return this.avOptionSecurisationMoinsValuesLimits.controls;
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
